export const outsideNavbarHeight = 100;
export const insideNavbarHeight = 70;
